module.exports = __webpack_public_path__ + "assets/3-Bullion_spec_hero.aed707a0.svg";